import {DOCUMENT_BORDER_SIZE, DOCUMENT_FORMAT} from "../../common/constant";
import {endDateMonth, threePrevMonth} from "./filters";
import {DOCUMENT_WATERMARK, PAGINATION} from "ubs-framework/v2/common/constant";

const initialState = {
    filter: {
        currentPage: PAGINATION.CURRENT_PAGE || 1,
        limit: PAGINATION.LIMIT || 20,
        search: '',
        jobTitle: null,
        status: null,
        recruiter: null,
        releaseBy: null,
        date: {
            startDate: threePrevMonth?.getTime(),
            endDate: endDateMonth?.getTime()
        }
    },
    active: 1,
    preboardingStep :[
        {name :"Kickoff", isActive: true , count: "0", key: "kickOff", icon: "Play"},
        {name :"Information Gathering", isActive: false , count: "0", key: "infoGathering", icon: "CheckList"},
        {name :"Verify Information", isActive: false, count: "0", key: "verifyInfo" , icon: "UserRight"},
        {name :"Release Offer", isActive: false, count: "0", key: "releaseOffer" , icon: "FilePreview"},
        {name :"Offer Acceptance", isActive: false, count: "0", key: "offerAcceptance" , icon: "NotSure"},
        {name :"Hired", isActive: false, count: "0", key: "hired" , icon: "CheckSign"},
    ],
    headerData: null,  //{heading Data from "ats|pre|boarding|user|fetch" api response}
    documents: {
        letterTypeList: [],
        letterList: [],
        document: {
            name: '',
            letterType: '',
            description: '',
            paperSize: DOCUMENT_FORMAT[1],
            orientation: 'portrait',
            isPageMargins: true,
            pageMargin: {
                top: 10,
                right: 10,
                bottom: 10,
                left: 10
            },
            isSelectableHeaderAndFooter: true,
            isBorderSize: false,
            borderSize: DOCUMENT_BORDER_SIZE[0],
            isPageNumber: false,
            isbodyContentEmpty: true,
            pageNumberPosition: {label: 'Footer', value: 'footer'},
            pageNumberAlignment: {label: 'Center', value: 'center'},
            placeHolders: [],
            headerContent: '',
            headerContentHeight: 0,
            footerContent: '',
            footerContentHeight: 0,
            bodyContent: '',
            removeFiles: [],
            fileDocRef : Math.random().toString(36).substr(2, 9).toString(),
            autoGeneratedDocument : {},
            isAutoGenerateNumber: false,
            watermark: {...DOCUMENT_WATERMARK.DEFAULT},
        },
        addPlaceHolder: {
            key: '',
            id: ''
        },
        assignedEmp: {
            // type: DOC_EMP_STATUS[0].value,
            type:1, // remove this temporary
            searchText: '',
            refresh: false
        },
        authorFields: [],
        signatureModal: {
            openModal: false,
            editSignatureId: null,
        },
        otherEmployee: {
            loading: false,
            error: false,
            data: {},
            documentId: "",
        },
        sendReminderUsers: {},
        userSignatureStatus: {},
        warningPopup: false,
        loader: false,
        isShowCalculate: false,
    },
    kickOff:{
        /* Modal With Without */
        open: false,
        withDoc:true,
        listItem: {},
        /* Modal With Without -end */
    },
    releaseOffer: {
        headerData : null, // {heading Data from "ats|pre|boarding|user|fetch" api response}

        /** Document salary template */
        salaryTemplateId : null ,  // id of selected salary template
        baseSalary: 0, // base Salary
        baseSalaryType : 2 , // monthly Default Selection
        isSalaryTemplate : false , // true when ["salTemp.monthlyCtc", "salTemp.annualCtc", "salTemp.salaryBreakup"] placeholder is available in document.
        salaryTemplateViewOnly : false, // True, if placeholders "salTemp.annualCtc", "salTemp.monthlyCtc", exist but this "salTemp.salaryBreakup" not exist it
        payFrequency : 1,
        isPT: false, // for professional text deduction,
        location: null,
        costOfCompany: 0,
        netPayable: 0,
        isGenerating: false,
        benefitPlans: []
    },
    leaveMulti: [''],
    verifyOffer:{
        approvalLevels:[
            // { _id:"", userLevel:""} /** level collected for multi level leave approval from HRMS >leave  HRMS > inbox > leave request */
        ],
        approveIDs:[],
        rejectIDs:[],
    },

    /** src/app-ats/preboarding/components/release-offer/job-details/index.js */
    saveData : false,
    email:"",
    replayTo: "",
    authorValue: {
        other : {},
        employee : {},
        authorized : {},
    },
    placeHolder: {},
    common: {
        viewCollectedDocuments: {
            open: false ,// flag to preview Collected Docs
            user: null , // pass user if in fetch API,
            data: null
        },
        viewOfferLetter : {
            open: false ,// flag to view Offere Letetr
            // user: null , // pass user if in fetch API,
            data: null
        },
        viewOfferEmail : {
            open: false ,// flag to view Offere Email
            data: null
        },
        viewFamilyInfo: {
            open: false ,// flag to preview Collected Docs
            user: null , // pass user if in fetch API,
            data: null
        },
    },
    addColumnOption: []

};


export default function (state = initialState, action) {
    switch (action.type) {
       /** change Steps*/
        case 'SET_ACTIVE': {
            return {...state, active: action.payload};
        }
        case 'SET_PREBOARDING_STEP': {
            let localState = state?.preboardingStep?.map(item=> {
                return ({...item, isActive: false})
            });
            localState[action.payload] = {...localState[action.payload] ,isActive: true};
            return {...state, preboardingStep : localState};
        }
        case 'SET_PREBOARDING_STEP_COUNT': {
            let localState = [...state?.preboardingStep]?.map(item=> {
                item.count = action.payload[item?.key] || "0";
                return item;
            });
            return {...state, preboardingStep : localState};
        }
        case  "SET_HEADER_DATA" :{
            return {...state, headerData : action?.payload};
        }

        /*** Kickoff step-1 */
        case 'KICKOFF': {
            if (action.payload.action === 'with-without-document') {
                return {...state, kickOff:{...state.kickOff,...action.payload.payload }}
            }
        }

        /*** Release Offer ***/
        case 'RELEASE_OFFER': {
            if (action.payload.action === 'setHeaderData') {
                return {...state, releaseOffer:{...state.releaseOffer,...action.payload.payload }}
            }else if(action.payload.action === 'setSalaryTemplateData'){
                return {...state, releaseOffer:{...state.releaseOffer,...action.payload.payload }}
            }else if(action.payload.action === 'setBaseSalary'){
                /** Base Salary Input Change */
                return {...state, releaseOffer:{...state.releaseOffer,...action.payload.payload }}
            }else if(action.payload.action === "save_state"){
                return {...state, ...action.payload.payload }
            }else if(action.payload.action === 'reset_state'){
                return {...state,
                    email:"",
                    replayTo: "",
                    authorValue: {
                        other : {},
                        employee : {},
                        authorized : {},
                    },
                    placeHolder: {}
                };
            }else if(action.payload.action === "set_pt"){
                return {...state, releaseOffer:{...state.releaseOffer,...action.payload.payload }}
            } else if (action.payload.action === "setIsGenerating") {
                return {...state, releaseOffer: {...state.releaseOffer, ...action.payload.payload}}
            } else if(action.payload.action === 'employeeBenefits'){
                return {...state, releaseOffer:{...state.releaseOffer,...action.payload.payload }}
            }
        }

        /** Preboarding Documents*/
        case 'UPDATE_DOCUMENTS': {
            let documents = JSON.parse(JSON.stringify({...state.documents}))
            if (action.payload.action === 'letter-type-list') {
                documents.letterTypeList = action.payload.letterTypeList
            } else if (action.payload.action === 'letter-list') {
                if (action.payload.hasOwnProperty('isDeleted')) {
                    action.payload.letterList = documents.letterList.map(letter => {
                        if (action.payload?._id) {
                            if (action.payload._id === letter._id) letter.isDeleted = action.payload.isDeleted
                        } else letter.isDeleted = false
                        return letter
                    })
                }
                documents.letterList = action.payload.letterList
            } else if (action.payload.action === 'reset') {
                documents.document = initialState.documents.document
            } else if (action.payload.action === 'placeholders') {
                documents.placeHolders = action.payload.placeHolders
            } else if (action.payload.action === 'add-placeholders') {
                documents.addPlaceHolder = {...documents.addPlaceHolder, ...action.payload.addPlaceHolder}
                documents.placeHolders = action.payload.placeHolders
            } else if (action.payload.action === 'assigned-emp') {
                documents.assignedEmp = {...documents.assignedEmp, ...action.payload.data}
            } else if (action.payload.action === 'removeFiles') {
                documents.document.removeFiles.push(action.payload.data)
            } else if (action.payload.action === 'editSignatureId') {
                documents.signatureModal = {...documents.signatureModal, editSignatureId: action.payload.data,}
            } else if (action.payload.action === 'openSignatureModal') {
                documents.signatureModal = {...documents.signatureModal, openModal: action.payload.data,}
            } else if (action.payload.action === 'setDocumentData') {
                documents.otherEmployee.data = {...documents.otherEmployee.data, data: action.payload.data,}
            } else if (action.payload.action === 'send-reminder-data') {
                documents.sendReminderUsers = {...documents.sendReminderUsers, ...action.payload.data,}
            } else if (action.payload.action === 'user-signature-status') {
                documents.userSignatureStatus = {...documents.userSignatureStatus, ...action.payload.data,}
            } else if (action.payload.action === 'valid-placeholders') {
                documents.document.validPlaceholders = action.payload.validPlaceholders
            } else if (action.payload.action === 'focus-invalid-placeholder') {
                documents.invalidPlaceholder = action.payload.invalidPlaceholder
            } else {
                documents.document = action.payload
            }
            return {...state, documents}
        }
        case 'SET_DOCUMENT_SAVE_WARNING': {
            return {...state, documents: {...state.documents, warningPopup: action?.payload}};
        }
        case 'SET_DOCUMENT_LOADER': {
            return {...state, documents: {...state.documents, loader: action?.payload}};
        }
        case 'SET_LEAVE_APPROVAL_REJECT_LEVEL' : {
            let localState = JSON.parse(JSON.stringify(state));
            /**
             * multiLevelLeave : is for when user approve leave we have to send levels and leaveId
             * approveIDs : is when bulk approval this is required
             * ***/
            if(action.payload.type === 'levels_approveID_rejectID'){
                return {...localState,
                    verifyOffer:{...localState.leave,
                        approvalLevels: [...action.payload?.data?.approvalLevels],
                        approveIDs: [...action.payload?.data?.approveIDs],
                        rejectIDs: [...action.payload?.data?.rejectIDs],}};
            }else return state;
        }
        case  "SET_COLLECTED_DOCUMENT": {
            let viewCollectedDocuments = JSON.parse(JSON.stringify(state?.common?.viewCollectedDocuments));
            if(action?.payload?.type === "open"){
                viewCollectedDocuments = {...viewCollectedDocuments, open: true, user: action.payload?.data?.user, data: action.payload?.data?.data}
            }else if(action?.payload?.type === "close"){
                viewCollectedDocuments = {...viewCollectedDocuments, open: false, user: null, data: null}
            }
            return {...state, common: {...state?.common, viewCollectedDocuments}}
        }
        case  "SET_OFFER_LETTER": {
            let viewOfferLetter = JSON.parse(JSON.stringify(state?.common?.viewOfferLetter));
            if(action?.payload?.type === "open"){
                viewOfferLetter = {...viewOfferLetter, open: true, data: action.payload?.data?.data};
            }else if(action?.payload?.type === "close"){
                viewOfferLetter = {...viewOfferLetter, open: false, data: null};
            }
            return {...state, common: {...state?.common, viewOfferLetter}}
        }
        case  "SET_OFFER_EMAIL": {
            let viewOfferEmail = JSON.parse(JSON.stringify(state?.common?.viewOfferEmail));
            if(action?.payload?.type === "open"){
                viewOfferEmail = {...viewOfferEmail, open: true, data: action.payload?.data};
            }else if(action?.payload?.type === "close"){
                viewOfferEmail = {...viewOfferEmail, open: false, data: null};
            }
            return {...state, common: {...state?.common, viewOfferEmail}}
        }
        case  "SET_VIEW_FAMILY_INFO": {
            let viewFamilyInfo = JSON.parse(JSON.stringify(state?.common?.viewFamilyInfo));
            if(action?.payload?.type === "open"){
                viewFamilyInfo = {...viewFamilyInfo, open: true, user: action.payload?.data?.user, data: action.payload?.data?.data};
            }else if(action?.payload?.type === "close"){
                viewFamilyInfo = {...viewFamilyInfo, open: false, user: null, data: null};
            }
            return {...state, common: {...state?.common, viewFamilyInfo}}
        }
        case 'GET_PREBOARDING_OPTION': {
            return {...state, addColumnOption: action.payload}
        }
        /** Filters of Preboarding List*/
        case 'FILTER_BOARDING_LIST': {
            return {...state, filter: {...state?.filter, ...action.payload}};
        }
        default: {
            return state;
        }
    }
}
